import { Octokit } from "octokit";

import { paginate, RequestDefaults } from "../api.js";

export type MergedPull = Awaited<ReturnType<typeof collectMergedPulls>>[number];

export async function collectMergedPulls(
	defaults: RequestDefaults,
	octokit: Octokit,
) {
	return await paginate(defaults, async (options) => {
		const response = await octokit.request("GET /search/issues", {
			page: options.page,
			per_page: options.per_page,
			q: `repo:${defaults.owner}/${defaults.repo}+is:pr+is:merged`,
		});

		return response.data.items;
	});
}
